<template>
    <header class="mdc-top-app-bar view-header"
        :style="basicData.thumbnail ? `background-image: url(${basicData.thumbnail}?s=360x256&t=fill&q=10&b=5);` : ''"
        :class="basicData.thumbnail ? 'darken' : ''"
        v-if="basicData">
        
        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)">arrow_back</a>
            </section>
            
            <section class="mdc-top-app-bar__section title">
                <div class="mdc-top-app-bar__title"></div>                
            </section>

            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
            </section>
        </div>
        <div class="pdt-16 pdb-20 pdl-16 pdr-16">
            <div class="t-headline6">
                {{basicData.name}}
            </div>
            <div class="t-body4 mgt-8">
                {{basicData.category.text}}{{basicData.category.child ? ' > ' + basicData.category.child.text : ''}}
            </div>
            <div class="t-body4 mgt-4" v-if="basicData.levels.length">
                <span v-for="(level, index) in basicData.levels" :key="index">
                    {{level.text}} {{basicData.levels.length === index+1 ? '' : '/' }}
                </span>
            </div>

            <div class="t-helper mgt-9 d-flex flex-row" v-if="basicData.tags.length">
                <span class="chip mgr-8" v-for="(tag, index) in basicData.tags" :key="index">#{{tag.name}}</span>
            </div>

            <div class="mgt-18 d-flex flex-row justify-content-between align-items-baseline">
                <div class="t-body3" v-if="basicData.goods">
                    <div v-if="basicData.goods.paymentPrice > 0">
                        {{basicData.goods.currency.key || 'USD'}}
                        <span class="t-headline5">
                            {{$n(basicData.goods.paymentPrice)}}
                            <!-- 결제금액 -->
                        </span>
                        <span class="t-body3 t-line-through-red mgr-7 mgl-7" v-if="basicData.goods.paymentPrice !== basicData.goods.price">
                            {{$n(basicData.goods.price)}}
                            <!-- 정가 -->
                        </span>
                    </div>
                    <div class="t-headline5" v-else>
                        {{$t('664')}}
                        <!-- free -->
                    </div>
                </div>
                <div class="t-body3 t-color-gray5">
                    {{setRegisterRestrictText}}
                    <!-- 정원정보 -->
                </div>
            </div>
            
            <div v-if="basicData.goods">
                <div class="mgt-14" v-for="(action, index) in basicData.actions" :key="index">
                    <button class="mdc-button mdc-button--raised btn-red w-full btn-big" 
                        :disabled="!action.enable" 
                        @click="actionDegree(action)"
                    >
                        {{basicData.goods.paymentPrice > 0 ? 
                                $t(action.translate, {str : $moment(action.translateParams.registerStart).format('L')}) :
                                $t('button.online.degree.enter')
                        }}

                    </button>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
/**
 * 차수 상세 헤더 컴포넌트(degree view header component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from '@/api/httpService'
import loginApi from '@/api/loginApi.js'
import degreeApi from '@/api/degreeApi.js'
import salesApi from '@/api/salesApi.js'
export default {
    data() {
        return {
            degreeId: null
        }
    },
    props: ['basicData'],

    computed: {
        // 정원 정보 노출(set register restrict)
        setRegisterRestrictText() {
            return this.basicData.capacity.registerRestrict.value === 'UNLIMITED_NUMBER' ? 
                    '' :
                    this.$t('605', {str1: this.basicData.capacity.learnerCount, str2: this.basicData.capacity.restrictCount})
        }
       
    },

    mounted() {
        this.degreeId = this.$route.params.degreeId
    },

    methods: {
        // 버튼 유효성 체크(validation button)
        actionDegree(action) {
            if (localStorage.getItem('token')) {
                // check auth token
                loginApi.validToken().then((response) => {
                    this.setAction(action)
                }).catch((err) => {
                    this.moveLogin()
                })
            } else {
                this.moveLogin()
            }
        },

        //로그인 이동(move login)
        moveLogin() {
            const loginPath = `/login?redirectPath=${encodeURIComponent(this.$route.fullPath)}`
            this.$confirm({
                    content: this.$t('934'), //'로그인 후 구매가 가능합니다. 로그인 하시겠습니까?',
                    accept: this.$t('935'),
                    cancel: this.$t('936')

                }).then(() => {
                }).catch(() => {                        
                    this.$router.push(loginPath)
                })
        },

        // 구매정보 조회(get Purchased history)
        getSalesGoodsPurchased() {
            return new Promise((resolve, reject) => {
                salesApi.salesGoodsPurchased({goodsId: this.basicData.goods.id}).then((response) => {
                    let purchasedData = response.data.data
                    resolve(purchasedData)
                }).catch((err) => {
                })  
            })
        },

        // 학습기간 조회(get learing status)
        getLearnPeriod() {
            return new Promise((resolve, reject) => {
                // 기간정보
                const params = {
                    degreeId: this.degreeId
                }
                degreeApi.guestLearnOnlineViewPeriod(params).then((response) => {
                    // this.periodData = response.data.data
                    resolve(response.data.data.learning)
                }).catch((err) => {
                    
                })
        
            })
        },

        
        // 버튼 동작 (button action)
        async setAction(action) {
            // ENTER / 수강신청/수강 신청 가능 할 때 추가 되는 정보로 수강신청 시 사용할 정보가 포함되어 있다.
            // ENTER_CANCEL / 수간신청 취소/수강 신청 취소 가능 할 때 추가 되는 정보로 수강 신청 취소 시 사용할 정보가 포함되어 있다.
            // AWAITER_ENTER / 대기자 신청하기/대기자 신청 가능 할 때 추가 되는 정보로 대기자 신청 시 사용할 정보가 포함되어 있다.
            // AWAITER_ENTER_CANCEL / 대기자 취소하기/대기자 신청 취소 가능 할 때 추가 되는 정보로 대기자 신청 취소 시 사용할 정보가 포함되어 있다.
            // BEFORE_LEARNING / 학습시작/학습 시작 가능 할 때 추가 되는 정보로 학습 시작 시 사용할 정보가 포함되어 있다.

            let confirmData = {}
        
            // action.id = 'AWAITER_ENTER_CANCEL'
            switch (action.id) {
                case 'ENTER':
                    let salesGoodsPurchasedList = await this.getSalesGoodsPurchased()
                    
                    let learnPeriod = await this.getLearnPeriod()
                    let messageDate = {}

                    let startDate = this.$moment(learnPeriod.start).format('l')
                    let endDate = learnPeriod.unlimited ? this.$t('50013') : this.$moment(learnPeriod.end).format('l')

                    if (this.basicData.goods.paymentPrice > 0) {    // is free
                        messageDate = {
                            title: this.$t('433'), //구매 전 확인
                            content: this.$t('434', {str1: startDate, str2: endDate}) + '<br>' + this.$t('416'), //본 강의의 학습 기간은 19.07.01 ~ 19.08.31입니다.구매를 계속 진행하시겠습니까?
                            accept: this.$t('436'), //계속
                            cancel: this.$t('435') //취소
                        }
                    }else {
                        messageDate = {
                            title: this.$t('980'), //수강신청 전 확인
                            content: this.$t('981', {str1: startDate, str2: endDate}) + '<br>' + this.$t('982'), //본 강의의 학습 기간은 19.07.01 ~ 19.08.31입니다.구매를 계속 진행하시겠습니까?
                            accept: this.$t('984'), //계속
                            cancel: this.$t('983') //취소
                        }

                    }

                    // console.log('salesGoodsPurchasedList', salesGoodsPurchasedList, learnPeriod, messageDate)

                    this.$confirm(messageDate).then(() => {
                        if (salesGoodsPurchasedList.length) {
                            this.$router.push({
                                name: 'SalesDuplicate', 
                                params: {goodsid: this.basicData.goods.id}, 
                                query: this.$route.query
                            })
                            return false
                        }

                        this.$router.push({
                            name: 'SalesInformation', 
                            params: {goodsid: this.basicData.goods.id}, 
                            query: this.$route.query
                        })

                    }).catch(() => {

                    })

                    break
                case 'ENTER_CANCEL':
                    confirmData = {
                        title: this.$t('50001'), //'수강신청 취소',
                        content: this.$t('50002'), //'수강신청을 취소하시겠습니까?',
                        accept: this.$t('939'),
                        cancel: this.$t('940')
                    }
                    this.$confirm(confirmData).then(() => {
                        this.enterCancel()
                    }).catch(() => {})
                    break
                case 'AWAITER_ENTER':
                    confirmData = {
                        title: this.$t('937'), //'대기자 신청',
                        content: this.$t('938'), //'현재 수강인원이 가득차 있습니다. 대기자 신청을 하시겠습니까?',
                        accept: this.$t('939'),
                        cancel: this.$t('940')
                    }
                    this.$confirm(confirmData).then(() => {
                        this.awaiterEnter()
                    }).catch(() => {})
                    break
                case 'AWAITER_ENTER_CANCEL':
                    confirmData = {
                        title: this.$t('941'), //'대기자 신청 취소',
                        content: this.$t('942'), //'대기자 신청을 취소하시겠습니까?',
                        accept: this.$t('943'),
                        cancel: this.$t('944')
                    }
                    this.$confirm(confirmData).then(() => {
                        this.awaiterEnterCancel()
                    }).catch(() => {})
                    break
                case 'BEFORE_LEARNING':
                    this.$router.push(`/learn/list?type=LEARNING`)
                    break
            }
        },

        // 대기자 신청 확인(check awaiter application)
        awaiterEnter() {
            let confirmData = {}
            confirmData = {
                title: this.$t('50003'), //'대기자 신청정보 확인',
                content: this.$t('50004'), //'공석발생시 전달받을 정보를 확인해주세요.<br>연락처 : 01020118284 <br> Email : koica@emcast.com',
                accept: this.$t('50006'),   //확인
                cancel: this.$t('50005')    //내 정보 수정
            }
            this.$confirm(confirmData).then(() => {
                this.awaiterEnter()
            }).catch(() => {
                this.$router.push({
                    name: 'DegreeEnterAwait', 
                    query: this.$route.query, 
                    params: this.$route.params})
            })
        },

        // 대기자 신청 취소(awaiter application cancel)
        awaiterEnterCancel() {
            // Todo
        },

        //수강 취소(enrollment cancel)
        enterCancel() {
            // Todo
        }
    }
}
</script>